import gsap from "gsap/all";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default () => ({
  init() {
    this.initAnimation();
  },

  hasDocumentReferrer() {
    return !!document.referrer;
  },

  initAnimation() {
    const inBackend = document.body.classList.contains("neos-backend");

    if (inBackend) return;

    const pageIntros = document.querySelectorAll(".page-intro");
    const animatedPageIntros = document.querySelectorAll(
      ".page-intro .should-animate"
    );

    /**
     * Animate Header Image
     * when header has both images set
     */
    animatedPageIntros.forEach((pageIntro) => {
      const backgroundImage = pageIntro.querySelector(".image-background");
      const foregroundImage = pageIntro.querySelector(".image-foreground");
      const circles = pageIntro.querySelector(".triple-half-moon");
      const gradientCirclesWrapper = pageIntro.querySelector(".triple-half-moon-wrapper");
      const newsTicker = document.querySelector(".ticker");
      const tweenProps = {
        duration: 1.3,
      };
      const gradientCircles = circles.querySelectorAll(
        ".gradient, .first, .second, .third"
      );

      gsap.set([ gradientCircles, backgroundImage, foregroundImage], {
        xPercent: -100,
      });

      let tl = gsap
        .timeline()
        .to(".should-animate", {
          opacity: 1,
        })
        .to([backgroundImage, foregroundImage], {
          xPercent: 0,
          opacity: 1,
          ...tweenProps,
        })
        .to(
          gradientCircles,
          {
            xPercent: 0,
            stagger: 0.2,
            duration: 0.7,
            delay: 0.7,
          },
          "<"
        );

      if (gradientCirclesWrapper) {
        tl.from(gradientCirclesWrapper, {
          opacity: 0,
        }).to(
          [gradientCirclesWrapper],
          {
            opacity: 1,
            stagger: 0,
            duration: 2.5,
            delay: 0,
          },
          "<-=1"
        );
      }

      if (newsTicker) {
        tl.add(
          gsap.from(".ticker", {
            opacity: 0,
          })
        );
      }
    });

    /**
     * Animate Text
     * when PageIntro has NO teaser because the Teaser component has its own animation
     */
    pageIntros.forEach((pageIntro) => {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: pageIntro,
            start: "top 265",
          },
        })
        .to(pageIntro.querySelectorAll(".double-half-moon .moon"), {
          opacity: 0.5,
          stagger: 0.15,
          duration: 2,
          delay: 0.5,
        });

      if (pageIntro.classList.contains("has-teaser")) return;

      gsap
        .timeline({
          scrollTrigger: {
            trigger: pageIntro,
            start: "top 265",
          },
        })
        .to(pageIntro.querySelectorAll(".slide-in-left"), {
          xPercent: 100,
          opacity: 1,
          stagger: 0.15,
          duration: 1,
          delay: animatedPageIntros.length > 0 ? 0.85 : 0,
          onComplete: function () {
            // clear transform to maintain responsiveness of element
            this.targets().forEach((el) => {
              el.classList.remove("slide-in-left");
              el.style.removeProperty("transform");
            });
          },
        });
    });
  },

  backButton() {
    return {
      ["@click"](event) {
        if (
          window.location.hash === "#history-back" &&
          window.history.length > 1
        ) {
          event.preventDefault();
          window.history.back();
        }
      },
    };
  },

  /**
   * Toggle widget
   */
  toggleWidget() {
    this.widgetExpanded = !this.widgetExpanded;
  },
});
